<template>
    <div class="col-12 slimline reg-size-form mt-3 mt-md-0 py-3 mx-0 shadow-sm">
        <div class="row justify-content-between align-items-center">
            <div class="col">
                <h3 class="h4">{{ typeof(customTitle) == 'undefined' ? title : customTitle }}</h3>
            </div>
            <transition name="fade" mode="out-in" :duration="{ enter: 300, leave: 300 }">
                <slimline-reg-form
                    v-if="visibleForm == 'reg'"
                    :postcode="postcode"
                    :brand="brand"
                    :price-range="priceRange"
                    :image-base-path="imageBasePath"
                    :mobile-fitting="mobileFittingLanding"
                    :view="view"
                    @toggleForm="toggleForm"
                ></slimline-reg-form>
                <slimline-size-form
                    v-else
                    :class="visibleForm == 'size' ? 'd-block' : 'd-none'"
                    :postcode="postcode"
                    :brand="brand"
                    :price-range="priceRange"
                    :options="options"
                    :mobile-fitting="mobileFittingLanding"
                    @toggleForm="toggleForm"
                ></slimline-size-form>
            </transition>
        </div>
   </div>
</template>

<script>
    export default {
        props: ['options', 'postcode', 'imageBasePath', 'customTitle', 'brand', 'priceRange', 'view'],
        components: {
        },
        data() {
            return {
                title: 'Find tyres for your car',
                visibleForm: 'reg'
            }
        },
        mounted() {
        },
        methods: {
            toggleForm(form) {
                this.visibleForm = form;
            }
        },
        computed: {
            mobileFittingLanding() {
                let segments = location.pathname.split('/');
                let mobileFitting = segments[1];
                
                return (mobileFitting == 'mobile-tyre-fitting' ? true : false);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .reg-size-form {
        background: #fff;
        box-shadow: 0 6px 6px -3px rgba(0,0,0,0.20), 0 10px 14px 1px rgba(0,0,0,0.14), 0 4px 18px 3px rgba(0,0,0,0.12);
        padding-left: 15px;
        border-left: 7px solid #395724;
        h1 {
            text-transform: uppercase;
            font-style: italic;
            font-weight: bold;
            text-align: left;
            margin-bottom: 5px;
        }
        h3 {
            text-align: left;
            margin: 0;
        }
    }
</style>